var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVideoRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627451   0 0 0 0 0.419607843   0 0 0 0 0.274509804  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9092171,15.5779224 C39.7623601,15.5259313 39.6211423,15.4998262 39.485445,15.4998262 C39.1803339,15.4998262 38.9263912,15.5989925 38.7228453,15.7967776 L31.8928673,22.078181 L31.8928673,19.500078 C31.8928673,18.260336 31.415493,17.2005927 30.4607445,16.3203009 C29.5059366,15.4401185 28.3566055,15 27.0118015,15 L15.0808284,15 C13.7364399,15 12.5867526,15.4401185 11.6318854,16.3203009 C10.6773743,17.2005927 10.2,18.260336 10.2,19.500078 L10.2,30.5000862 C10.2,31.7397188 10.6773743,32.7994073 11.6319447,33.6796444 C12.586812,34.5598815 13.7364992,35 15.0808877,35 L27.0119202,35 C28.3566649,35 29.5060553,34.5598815 30.4608632,33.6796444 C31.4156117,32.7994073 31.892986,31.7397735 31.892986,30.5000862 L31.892986,27.906167 L38.722964,34.2031676 C38.9265099,34.4008981 39.1804526,34.5 39.4855638,34.5 C39.6212611,34.5 39.7624788,34.4739593 39.9093358,34.4220776 C40.3502036,34.2449247 40.5703704,33.9377393 40.5703704,33.5002476 L40.5703704,16.500026 C40.5703704,16.0623155 40.3500255,15.7550753 39.9092171,15.5779224 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium+-upgrade",
    transform: "translate(-9.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icVideoRed",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F76B46",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoRed);
export default __webpack_public_path__ + "static/media/icVideoRed.939c2d6976dfb70e26d3126b2734323d.svg";
export { ForwardRef as ReactComponent };